import React, { Component } from 'react';
import PropTypes from 'prop-types';
import replace from 'lodash/replace';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Link from 'components/link';

import linksDomik from 'src-sites/domik/links';
import { phoneDomik } from 'src-sites/domik/config';

import { sectionId, renderLinkTerms } from '../page-terms';

import translates from '../terms-i18n.json';

import 'styles/domik/section-terms/_page-terms.scss';

const bemClasses = new Bem('pageTerms');

@I18nHoc(translates)
export default class DocUserAgreementSite extends Component {
  static propTypes = {
    blockRef: PropTypes.func,
    blockId: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { blockRef, blockId } = this.props;

    const linkToContacts = (
      <Link
        {...bemClasses('link')}
        builder={linksDomik.sectionContacts}
        builderProps={{ title: i18n('contacts') }}
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text', 'link')} children={`«${i18n('contacts')}»`} />
        </span>
      </Link>
    );
    const telDomik = (
      <Link
        {...bemClasses('link', 'tel')}
        href={`tel:${replace(phoneDomik, /[\s\(\)]/g, '')}`}
        external
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text')} children={phoneDomik} />
        </span>
      </Link>
    );
    const docsMain = (
      <>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[1], i18n('privacyPolicy'))}.
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[2], i18n('useCookies'))}.
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[3], i18n('termsUseMaterials'))}.
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[6], i18n('conceptRulesForum'), false, true)}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[4], i18n('rulesPublishingAnnouncements'))}.
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {renderLinkTerms.call(this, sectionId[5], i18n('rulesPublishingDisplayAd'))}.
          </span>
        </li>
      </>
    );
    const docsMainWithText = (
      <>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 1&ensp;
            {renderLinkTerms.call(this, sectionId[1], i18n('privacyPolicy'))}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 2&ensp;
            {renderLinkTerms.call(this, sectionId[2], i18n('useCookies'))}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 3&ensp;
            {renderLinkTerms.call(this, sectionId[3], i18n('termsUseMaterials'))}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 4&ensp;
            {renderLinkTerms.call(this, sectionId[6], i18n('conceptRulesForum'), false, true)}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 5&ensp;
            {renderLinkTerms.call(this, sectionId[4], i18n('rulesPublishingAnnouncements'))}
          </span>
        </li>
        <li {...bemClasses('li')}>
          <span {...bemClasses('text')}>
            {i18n('application')} № 6&ensp;
            {renderLinkTerms.call(this, sectionId[5], i18n('rulesPublishingDisplayAd'))}
          </span>
        </li>
      </>
    );

    return (
      <div
        {...bemClasses('section', 'userAgreementSite')}
        ref={blockRef}
        id={blockId}
      >
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Пользовательское соглашение сайта Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>В соответствии со ст. 634 Гражданского кодекса Украины (ГКУ) настоящий договор (далее – Соглашение) заключается между ЧП «РА» ДОМИК НЕТ» юр. адрес: 04210, г. Киев, Оболонский р-н, пр. Героев Сталинграда, 6б, кор. 3, оф.1, код ЕГРПОУ 36080646, (далее – <b>Компания</b>) и любым юридическим или физическим лицом, определенным в Соглашении как <b>Пользователь</b>, путем присоединения Пользователя к Соглашению следующими способами:</p>
          </div>
          <ol {...bemClasses('ol', 'lowerAlpha')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>нажатием кнопки или установления отметки рядом с пунктом «Принимаю» или «Соглашаюсь» там, где это предлагается Порталом;</span>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>использованием какого-либо, нескольких или всех сервисов. В этом случае, Пользователь понимает и соглашается, что он принимает настоящее Соглашение на протяжении всего срока использования Сервисов.</span>
            </li>
          </ol>
          <div {...bemClasses('text')}>
            <p>Условия Соглашения, которые принимает Пользователь перечислены ниже.</p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Определение терминов, используемых в настоящем Соглашении:" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>
                    <b>Портал</b> – интернет-сайт {renderLinkToMain.call(this, 'https://www.domik.ua')} со всеми поддоменами.
                  </span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Владелец Портала</b> – физическое или юридическое лицо, которому принадлежит или будет принадлежать домен и/или Портал.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Пользователь</b> – любое дееспособное физическое или юридическое лицо, пользующееся Сервисами Портала.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Сервисы</b> – все и любые платные и/или бесплатные услуги, оказываемые Компанией Пользователям при помощи Портала, включая, но не ограничиваясь таким перечнем:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервисы, доступные как для зарегистрированных, так и для незарегистрированных Пользователей, то есть:" />
                      <ul {...bemClasses('ul', 'hyphen')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="ознакомление с новостями, аналитикой, статистикой, фото, видео и другими материалами, размещенными на Портале;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="чтение объявлений, размещенных на Портале;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="калькуляторы недвижимости;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="регистрация Пользователя;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="создание Аккаунта и Личного кабинета Пользователя;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="размещение рекламы." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервисы, доступные для зарегистрированных Пользователей, а именно:" />
                      <ul {...bemClasses('ul', 'hyphen')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="общение на форуме и комментирование новостей;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="размещение объявлений на Портале;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="продвижение объявлений на Портале;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="изменение статуса Аккаунта Пользователя на Портале;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="открытие личного счета Пользователя;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="оплата платных Сервисов посредством личного счета Пользователя или через интегрированные платежные системы." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Другие Сервисы, которые оказываются или будут оказываться Компанией зарегистрированным или незарегистрированным Пользователям через Портал." />
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Регистрация</b> – процедура заполнения Пользователем соответствующих форм, в результате которой Пользователь создает Аккаунт на Портале, получает доступ в Личный кабинет, а также к Сервисам и функциям, доступным для зарегистрированных Пользователей. Регистрация может быть осуществлена, также, с использованием данных учетной записи Пользователя в социальных сетях.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Аккаунт</b> – создаваемая Пользователем и принадлежащая Компании учетная запись Пользователя, которая представляет собой совокупность данных о Пользователе, необходимых для авторизации (аутентификация) Пользователя на Портале и доступа к его Личному кабинету.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Личный кабинет</b> – электронный кабинет <b>Пользователя</b> на Портале, с помощью которого он может размещать объявления и управлять ими, пополнять свой счет, а также заказывать и/или оплачивать Сервисы, доступные для заказа и/или оплаты через Личный кабинет.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Контент Компании</b> – любые и все материалы и информация, которые размещает Компания на Портале, включая, но не ограничиваясь (статьи, новости, аналитика, объявления, изображения, фотографии, сообщения и др.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Контент Пользователя</b> – любые и все материалы и информация, которые размещает Пользователь на Портале, включая, но, не ограничиваясь (объявления, изображения, фотографии, видео, сообщения, комментарии, баннеры, реклама и др.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Ключевые документы:</b></span>
                  <ul {...bemClasses('ul', 'hyphen')} children={docsMain} />
                  <span {...bemClasses('text')}>Ключевые документы являются неотъемлемой частью Соглашения.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Предмет Соглашения" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>В соответствии с настоящим Соглашением Компания предоставляет Пользователю Сервис в объеме, предусмотренном функциональными возможностями Портала, при условии соблюдения Пользователем настоящего Соглашения и Ключевых документов.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права и обязанности Пользователя" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Пользователь имеет право:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Свободно осуществлять поиск, получение, передачу, производство и распространение на Портале информации, которая не противоречит требованиям настоящего Соглашения и Ключевых документов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Пользоваться Сервисами в объеме, предусмотренном настоящим Соглашением и Ключевыми документами." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>Обращаться к администрации Портала с предложениями, замечаниями или жалобами, касающимися работы Портала, условий настоящего Соглашения и Ключевых документов по форме обратной связи, расположенной на странице {linkToContacts}.</span>
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Пользователь обязуется:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Перед использованием Сервисов ознакомиться с условиями данного Соглашения и Ключевых документов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Соблюдать условия настоящего Соглашения и Ключевых документов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Покинуть Портал, если Пользователь не согласен с Соглашением и/или Ключевыми документами полностью или частично." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="При Регистрации предоставить правдивую, точную и полную информацию о себе по вопросам, предлагаемым в форме Регистрации и раздела сайта «Личный кабинет». А также поддерживать эту информацию в актуальном состоянии." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не выдавать себя за другого человека или представителя организации, которым на самом деле не является." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Нести ответственность за безопасность своего логина и пароля, а также за все, что будет сделано на сайте под его логином и паролем. Пользователь обязуется немедленно уведомить Компанию о любом случае неавторизованного (не разрешенного Пользователем) доступа с логином и паролем Пользователя и/или о любом нарушении безопасности." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не использовать сайт для отправки в чей-либо адрес электронных писем или сообщений, содержащих грубые и оскорбительные выражения и предложения, а также материалы порнографического характера." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не вводить в заблуждение других Пользователей относительно свойств и характеристик каких-либо субъектов или объектов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не использовать самостоятельно или с привлечением третьих лиц возможности Портала в целях, которые могут быть квалифицированы как нарушение прав третьих лиц на объекты интеллектуальной собственности, недобросовестная конкуренция, иное нарушение действующего законодательства Украины." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не осуществлять действий, которые повлияют на нормальную работу Портала и являются его недобросовестным использованием." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не предпринимать никаких действий, которые могут привести к непропорционально большой нагрузке на инфраструктуру Портала." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не использовать автоматические программы для получения доступа на Портал." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не копировать, не воспроизводить, не изменять, не распространять и не представлять общественности любую информацию, содержащуюся на Портале, кроме как на условиях настоящего Соглашения или Ключевых документов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не использовать сведения, предоставленные другими Пользователями, в иных целях, кроме как для коммуникации и/или совершения сделки непосредственно с этим Пользователем, без письменного разрешения другого Пользователя." />
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права и обязанности Компании" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Компания имеет право:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Изменять функциональные возможности Портала. Самостоятельно определять порядок оказания и стоимость платных Сервисов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Отказать в регистрации Пользователю, который указал о себе недостоверные данные или нарушил другие условия данного Соглашения, либо деактивировать его регистрацию, если это зарегистрированный пользователь." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Удалить или заблокировать Аккаунт Пользователя, ограничить его доступ к Порталу без предупреждения, в случаях, если Пользователь:" />
                      <ul {...bemClasses('ul', 'disc')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="нарушает действующее законодательство Украины, условия настоящего Соглашения и/или Ключевых документов;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="нарушает права или законные интересы других Пользователей Портала, юридических и физических лиц по их мотивированному обращению;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="не реагирует на обращения Компании, отправленные на электронный адрес Пользователя, указанный при Регистрации." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Удалить или заблокировать Аккаунт Пользователя в любых случаях, по усмотрению Компании, при предоставлении Пользователю соответствующего обоснования." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Восстановить доступ Пользователя к Порталу." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Устанавливать ограничения по использованию Сервисов." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Изменять или прекращать работу Портала или их части с уведомлением Пользователя или без него, не неся при этом ответственности за подобные изменения или прекращения." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="В любой момент потребовать от Пользователя подтверждения данных, указанных им при Регистрации, и запросить в связи с этим подтверждающие документы (заверенные копии документов, удостоверяющих личность). Непредоставление вышеперечисленных документов, по усмотрению Пользователя, может быть приравнено к предоставлению недостоверной информации." />
                    </li>
                  </ol>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Компания обязуется:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Прилагать все усилия для должного исполнения своих обязанностей по настоящему Соглашению, включая нормальную работу Сервисов Портала." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>
                        Соблюдать конфиденциальность данных Пользователя согласно&ensp;
                        {renderLinkTerms.call(this, sectionId[1], 'Политике конфиденциальности')}
                        .
                      </span>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Стоимость Сервисов и порядок оплаты" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Сервисы, оказываемые Компанией, могут быть платными и бесплатными.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Если иное не указано в настоящем Соглашении и Ключевых документах, Регистрация Пользователя на Портале, создание Аккаунта, доступ к Личному кабинету, чтение объявлений, размещенных на Портале, ознакомление с новостями, аналитикой, фото, видео и другими материалами, размещенными на Портале, общение на форуме и комментирование новостей являются бесплатными Сервисами.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания в одностороннем порядке определяет, какой Сервис Портала является бесплатным, а какой платным, а также, стоимость платных сервисов. Компания размещает информацию о перечне и стоимости платных сервисов в Личном кабинете Пользователя и/или в соответствующих разделах Портала.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь обязуется ознакомиться с ценами на платные Сервисы Компании до их заказа.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Оплата платных Сервисов осуществляется через Личный кабинет Пользователя, при помощи интегрированных платежных систем или в другом порядке, согласованном между Пользователем и Компанией.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Возврат оплаченных денежных средств за не оказанные Сервисы осуществляется Компанией в следующих случаях:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>автоматически функциональной системой Портала за каждое удаленное при модерации объявление (кроме объявлений, удаленных как неактуальные), если объявление оплачено. Возврат денежных средств осуществляется за те дни, в которых услуга не предоставлялась;</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>если по причине любой технической неполадки услуга не предоставлялась, возврат оплаченных денежных средств осуществляется после предоставления пользователем доказательств оплаты. В таком случае возврат денежных средств отображается в Аккаунте Пользователя с возможностью использования оплаченных денежных средств в будущем;</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>при оплате Сервиса с удалённых Компанией учетных записей, которые были продублированы Пользователем в нарушение условий данного Соглашения. Такой возврат осуществляется Компанией исключительно по обращению Пользователя, а денежные средства возвращаются на активную учетную запись такого пользователя с возможностью использования оплаченных денежных средств в будущем.</span>
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Денежные средства, Пользователям, Аккаунты которых заблокированы или удалены на основании пункта 4.1.4. настоящего Соглашения, не возвращаются.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права интеллектуальной собственности" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Все объекты, доступные при помощи Сервисов, в том числе элементы дизайна, текст, графические изображения, иллюстрации, видео, программы, базы данных, музыка, звуки и другие объекты, а также любой контент, размещенный на сервисах Портала, являются объектами исключительных прав Компании, Пользователей и других правообладателей. Никакие элементы содержания сервисов Портала, а также любой контент, размещенный на сервисах Портала, не могут быть использованы иным образом без предварительного разрешения Компании или Правообладателя. Под использованием подразумеваются, в том числе, но не исключительно (воспроизведение, копирование, переработка, распространение на любой основе и др.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Название Портала является зарегистрированной торговой маркой и охраняется действующим законодательством Украины, а также международным.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Портал и Контент Компании является объектом авторского права, охраняемым действующим законодательством Украины.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания не разрешает использование названия Портала и/или Контента Компании, кроме как на условиях письменного лицензионного договора, если иное не указано в настоящем Соглашении или Ключевых Документах.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Являясь объектом авторского права Компании, Портал одновременно включает Контент Пользователя. Пользователь предоставляет Компании действующее без ограничения территории и срока неисключительное, сублицензируемое право на использование Контента Пользователя любыми способами, включая, но не ограничиваясь (публикация, сбор, демонстрация, копирование, дублирование, воспроизведение, доведение до всеобщего сведения). Перечисленные выше права предоставляются Компании безвозмездно (без выплаты вознаграждения).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь соглашается с тем, что его Контент может быть использован Компанией по собственному усмотрению при подготовке рекламных материалов, статей, отчетов, анализов и прочего без дополнительного согласия со стороны Пользователя и без выплаты вознаграждения.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь предоставляет право на доступ к его Контенту всем Пользователям Портала.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь гарантирует и несет всю ответственность за соблюдение авторских прав на его Контент и возмещает Компании все убытки, понесенные последней в случае урегулирования претензий и споров с участием третьих лиц, возникших в связи с нарушением Пользователем прав интеллектуальной собственности на предоставленную им информацию.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Ограничение ответственности Компании и Владельца Портала" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь понимает и полностью соглашается с тем, что:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="хозяйственную деятельность и оказание Сервисов через Портал осуществляет Компания. Поэтому, Владелец Портала не несет ответственности перед Пользователями, в том числе и по настоящему Соглашению, если иное прямо не предусмотрено законодательством;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервис предоставляется на условиях «как есть». Компания прилагает все усилия для непрерывного и безошибочного оказания Сервиса Пользователю, но не гарантирует ошибок и сбоев, в том числе в отношении работы программного обеспечения. Компания предпримет все усилия для устранения каких-либо сбоев и ошибок, в случае их возникновения, в максимально короткие сроки;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не несет ответственности за любой несанкционированный доступ или использование серверов Портала и/или любой хранящейся на них информации о Пользователях, а также за любые ошибки, вирусы, «троянские кони» и прочее, которые могут быть переданы на Портал или через него третьими лицами;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не гарантирует, что Сервисы будут соответствовать требованиям Пользователя;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не гарантирует, что качество товаров и услуг, приобретенных с помощью Портала, будет соответствовать ожиданиям и/или требованиям Пользователя;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не является организатором/инициатором/гарантом сделок между Пользователями. Портал является коммуникационной платформой, которая предоставляет Пользователям возможность общения и размещения их Контента в соответствии с данным Соглашением и Ключевыми документами;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Весь Контент Компании публикуется на Портале исключительно с информационной целью и Пользователь не может ссылаться на него, как на экспертные заключения, если иное прямо не сказано в определенном Контенте;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не может контролировать достоверность размещаемой Пользователями информации. Компания не несет ответственности за какой-либо ущерб, причиненный в результате не совершения сделки или ненадлежащего поведения какой-либо из сторон сделки;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Пользователь обязуется соблюдать осторожность и сохранять здравый смысл при пользовании Сервисами. Пользователь должен принять во внимание, что его контрагент может быть несовершеннолетним или выдавать себя за другое лицо. Использование Сервисов подразумевает, что Пользователь осознает и принимает эти риски, а также соглашается, что Компания не несет ответственности за действие или бездействие со стороны Пользователя;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компания не несет ответственности за поведение Пользователей и/или за Контент Пользователей. Все споры и конфликты между Пользователями решаются ими самостоятельно без привлечения Компании;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="если у Пользователя возникают претензии к другому Пользователю в результате использования Сервисов, Пользователь соглашается предъявлять эти требования самостоятельно и без вмешательства со стороны Компании, а также освобождает Компанию от всех требований, обязательств, компенсаций по возмещению ущерба, убытков, затрат и издержек, включая расходы на юридические услуги, возникшие в результате или в связи с такими требованиями;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="скачивание любой информации или материалов с Портала осуществляется на свой страх и риск. Пользователи полностью ответственны за потерю информации или вред, нанесенный их компьютеру вследствие скачивания информации с Портала;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="бездействие со стороны Компании в случае нарушения Пользователем либо иными пользователями положений Соглашения не лишает Компанию права предпринять соответствующие действия в защиту своих интересов позднее, а также не означает отказа Компании от своих прав в случае совершения в последующем подобных нарушений." />
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Внесение изменений в соглашение" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>
                    Соглашение может быть изменено Компанией в одностороннем порядке без какого-либо специального уведомления Пользователя. Новая редакция Соглашения вступает в силу с момента ее размещения в сети Интернет по указанному в настоящем абзаце Соглашения адресу, если иное не предусмотрено новой редакцией Соглашения. Действующая редакция Соглашения всегда находится на Портале по адресу:&ensp;
                      <Link
                        {...bemClasses('link')}
                        builder={linksDomik.sectionTermsUse}
                        builderProps={{ title: i18n('termsUser') }}
                      >
                        <span {...bemClasses('linkContent')}>
                          <span {...bemClasses('text', 'link')} children={`https://www.domik.ua/copyright.html#${sectionId[0]}`} />
                        </span>
                      </Link>
                    .
                  </span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Срок действия Соглашения" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Настоящее Соглашение вступает в силу с момента его принятия Пользователем в порядке, указанном выше, и действует на протяжении всего периода использования Пользователем Сервисов.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Пользователь имеет право прекратить свою регистрацию на Портале в одностороннем порядке без предварительного уведомления об этом Компании и объяснения причин.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>В случае, если Компанией были внесены какие-либо изменения в Соглашение в порядке, предусмотренном пунктом 8 Соглашения, с которыми Пользователь не согласен, он обязан прекратить использование Сервисов. Факт не прекращения использования Портала является подтверждением согласия Пользователя с соответствующей редакцией Соглашения.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компания имеет право расторгнуть Соглашение путем удаления или блокирования Аккаунта Пользователя в случаях, предусмотренных пунктами 4.1.4 и 4.1.5 Соглашения.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Приложения к Договору:" />
              <ul {...bemClasses('ul', 'hyphen')} children={docsMainWithText} />
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Реквизиты Компании:" />
              <div {...bemClasses('text')}>
                <p children="Частное предприятие «РЕКЛАМНОЕ АГЕНТСТВО ДОМИК НЕТ»," />
                <p children="ЕГРПОУ 36080646" />
                <p children="юр. адрес: 04210, г. Киев, Оболонский р-н, пр-т Героев Сталинграда, 6б, кор. 3, оф.1" />
                <p>тел.: {telDomik}</p>
              </div>
            </li>
          </ol>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Угода сайту Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>Відповідно до ст. 634 Цивільного кодексу України (ЦКУ) цей договір (далі — Угода) укладається між ПП «РА ДОМІК НЕТ» юр. адреса: 04210, м. Київ, Оболонський р-н, пр-т Героїв Сталінграда, 6б, кор. 3, оф.1, ЄДРПОУ 36080646 (далі — <b>Компанія</b>) і будь-якою юридичною або фізичною особою, зазначеною в Угоді як <b>Користувач</b>, шляхом приєднання Користувача до Угоди наступними способами:</p>
          </div>
          <ol {...bemClasses('ol', 'lowerAlpha')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>натисканням кнопки або встановлення позначки поряд із пунктом «Приймаю» або «Погоджуюся» там, де це пропонується Порталом;</span>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>використанням будь-якого, декількох або всіх Сервісів. У цьому випадку, Користувач розуміє і погоджується, що він приймає цю Угоду протягом усього терміну використання Сервісів.</span>
            </li>
          </ol>
          <div {...bemClasses('text')}>
            <p>Умови Угоди, які приймає Користувач перераховані нижче.</p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Визначення термінів, які використовуються в цій Угоді:" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>
                    <b>Портал</b> — інтернет-сайт {renderLinkToMain.call(this, 'https://www.domik.ua')} з усіма піддоменами.
                  </span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Власник Порталу</b> — фізична або юридична особа, якій належить або буде належати домен і/або Портал.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Користувач</b> — будь-яка дієздатна фізична або юридична особа, яка користується Сервісами Порталу.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Сервіси</b> — все і будь-які платні і/або безкоштовні послуги, що надаються Компанією Користувачам за допомогою Порталу, включаючи, але не обмежуючись таким переліком:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервіси, доступні як для зареєстрованих, так і для незареєстрованих користувачів, тобто:" />
                      <ul {...bemClasses('ul', 'hyphen')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="ознайомлення з новинами, аналітикою, статистикою, фото, відео та іншими матеріалами, розміщеними на Порталі;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="читання оголошень, розміщених на Порталі;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="калькулятори нерухомості;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="реєстрація користувача;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="створення Акаунта і Особистого кабінету Користувача;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="розміщення реклами." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервіси, доступні для зареєстрованих користувачів, а саме:" />
                      <ul {...bemClasses('ul', 'hyphen')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="спілкування на форумі та коментування новин;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="розміщення оголошень на Порталі;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="просування оголошень на Порталі;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="зміна статусу Акаунта Користувача на Порталі;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="відкриття особистого рахунку Користувача;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="оплата платних Сервісів за допомогою особистого рахунку Користувача або через інтегровані платіжні системи." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Інші Сервіси, які є або будуть Компанією зареєстрованим або незареєстрованим Користувачам через Портал." />
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Реєстрація</b> — процедура заповнення Користувачем відповідних форм, в результаті якої Користувач створює Акаунт на Порталі, отримує доступ до Особистого кабінету, а також до Сервісів і функцій, доступним для зареєстрованих користувачів. Реєстрація може бути здійснена, також, з використанням даних облікового запису Користувача в соціальних мережах.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Аккаунт</b> — створений Користувачем і належить Компанії обліковий запис Користувача, який представляє собою сукупність даних про Користувача, необхідних для авторизації (аутентифікації) Користувача на Порталі та доступу до його Особистого кабінету.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Особистий кабінет</b> — електронний кабінет Користувача на Порталі, за допомогою якого він може розміщувати оголошення та керувати ними, поповнювати свій рахунок, а також замовляти і/або оплачувати Сервіси, доступні для замовлення і/або оплати через особистий кабінет.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Контент Компанії</b> — будь-які і всі матеріали і інформація, які розміщує Компанія на Порталі, включаючи, але не обмежуючись (статті, новини, аналітика, оголошення, зображення, фотографії, повідомлення та ін.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Контент Користувача</b> — будь-які і всі матеріали і інформація, які розміщує Користувач на Порталі, включаючи, але не обмежуючись (оголошення, зображення, фотографії, відео, повідомлення, коментарі, банери, реклама та ін.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}><b>Ключові документи:</b></span>
                  <ul {...bemClasses('ul', 'hyphen')} children={docsMain} />
                  <span {...bemClasses('text')}>Ключові документи є невід'ємною частиною Угоди.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Предмет Угоди" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Відповідно до цієї Угоди Компанія надає Користувачеві Сервіс в обсязі, передбаченому функціональними можливостями Порталу, за умови дотримання Користувачем цієї Угоди і Ключових документів.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права та обов'язки Користувача" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Користувач має право:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Вільно здійснювати пошук, отримання, передачу, виробництво і поширення на Порталі інформації, яка не суперечить вимогам цієї Угоди та Ключових документів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Користуватися Сервісами в обсязі, передбаченому цією Угодою та Ключовими документами." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>Звертатися до адміністрації Порталу з пропозиціями, зауваженнями або скаргами, що стосуються роботи Порталу, умов цієї Угоди та Ключових документів за формою зворотного зв'язку, розташованою на сторінці {linkToContacts}.</span>
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Користувач зобов'язується:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Перед використанням Сервісів ознайомитися з умовами цієї Угоди та Ключових документів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Дотримуватися умов цієї Угоди та Ключових документів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Покинути Портал, якщо Користувач не згоден з Угодою та/або Ключовими документами повністю або частково." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Під час Реєстрації надати правдиву, точну і повну інформацію про себе з питань, запропонованих у формі Реєстрації та розділу сайту «Особистий кабінет». А також підтримувати цю інформацію в актуальному стані." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не видавати себе за іншу людину або представника організації, яким насправді не є." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Нести відповідальність за безпеку свого логіна і пароля, а також за все, що буде зроблено на сайті під його логіном та паролем. Користувач зобов'язується негайно повідомити Компанію про будь-який випадок неавторизованого (дозволеного Користувачем) доступу з логіном і паролем Користувача і/або про будь-яке порушення безпеки." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не використовувати сайт для відправки на будь-чию адресу електронних листів або повідомлень, що містять грубі та образливі вирази і пропозиції, а також матеріали порнографічного характеру." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не вводити в оману інших користувачів щодо властивостей і характеристик будь-яких суб'єктів або об'єктів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не використовувати самостійно або із залученням третіх осіб можливості Порталу з метою, які можуть бути кваліфіковані як порушення прав третіх осіб на об'єкти інтелектуальної власності, недобросовісна конкуренція, інше порушення чинного законодавства України." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не здійснювати дій, які вплинуть на нормальну роботу Порталу і є його несумлінним використанням." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не вживати ніяких дій, які можуть призвести до непропорційно великого навантаження на інфраструктуру Порталу." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не використовувати автоматичні програми для отримання доступу на Портал." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не копіювати, не відтворювати, не змінювати, не поширювати і не представляти громадськості будь-яку інформацію, що міститься на Порталі, крім як на умовах цієї Угоди або Ключових документів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Не використовувати відомості, надані іншими Користувачами, в інших цілях, крім як для комунікації і/або здійснення угоди безпосередньо з цим Користувачем, без письмового дозволу іншого Користувача." />
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права і обов'язки Компанії" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Компанія має право:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Змінювати функціональні можливості Порталу. Самостійно визначати порядок надання та вартість платних Сервісів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Відмовити в реєстрації Користувачеві, який вказав про себе недостовірні дані або порушив інші умови даної Угоди, або деактивувати його реєстрацію, якщо це зареєстрований користувач." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Видалити або заблокувати Акаунт Користувача, обмежити його доступ до Порталу без попередження, у випадках, якщо Користувач:" />
                      <ul {...bemClasses('ul', 'disc')}>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="порушує чинне законодавство України, умови цієї Угоди та/або Ключових документів;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="порушує права або законні інтереси інших користувачів Порталу, юридичних і фізичних осіб за їхнім мотивованим зверненням;" />
                        </li>
                        <li {...bemClasses('li')}>
                          <span {...bemClasses('text')} children="не реагує на звернення Компанії, відправлені на електронну адресу Користувача, вказану під час реєстрації." />
                        </li>
                      </ul>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Видалити або заблокувати Акаунт Користувача в будь-яких випадках, на розсуд Компанії, за надання Користувачеві відповідного обґрунтування." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Відновити доступ Користувача до Порталу." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Встановлювати обмеження щодо використання Сервісів." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Змінити або припинити роботу Порталу або їхні частини з повідомленням Користувача або без нього, не несучи при цьому відповідальності за подібні зміни або припинення." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="У будь-який момент зажадати від Користувача підтвердження даних, зазначених ним під час реєстрації, і запросити в зв'язку з цим підтверджуючі документи (завірені копії документів, що засвідчують особу). Ненадання перерахованих вище документів, на розсуд Користувача, може бути прирівняне до надання недостовірної інформації." />
                    </li>
                  </ol>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text', 'italic underline')}>Компанія зобов'язується:</span>
                  <ol {...bemClasses('ol', 'list')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Докладати всіх зусиль для належного виконання своїх обов'язків за цією Угодою, включаючи нормальну роботу Сервісів Порталу." />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>
                        Дотримуватися конфіденційності даних Користувача згідно з&ensp;
                        {renderLinkTerms.call(this, sectionId[1], 'Політикою конфіденційності')}
                        .
                      </span>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Вартість Послуг та порядок оплати" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Сервіси, що надаються Компанією, можуть бути платними і безкоштовними.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Якщо інше не зазначено в цій Угоді та Ключових документах, Реєстрація Користувача на Порталі, створення Акаунта, доступ до Особистого кабінету, читання оголошень, розміщених на Порталі, ознайомлення з новинами, аналітикою, фото, відео та іншими матеріалами, розміщеними на Порталі, спілкування на форумі та коментування новин є безкоштовними Сервісами.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія в односторонньому порядку визначає, який Сервіс Порталу є безкоштовним, а який платним, а також, вартість платних сервісів. Компанія розміщує інформацію про перелік і вартість платних сервісів в Особистому кабінеті Користувача і/або у відповідних розділах Порталу.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач зобов'язується ознайомитися з цінами на платні Сервіси Компанії до їхнього замовлення.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Оплата платних Сервісів здійснюється через Особистий кабінет Користувача, за допомогою інтегрованих платіжних систем або в іншому порядку, узгодженому між Користувачем та Компанією.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Повернення сплачених грошових коштів за ненадані Сервіси здійснюється Компанією в наступних випадках:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>автоматично функціональною системою Порталу за кожне видалене при модерації оголошення (крім оголошень, видалених як неактуальні), якщо оголошення оплачено. Повернення грошових коштів здійснюється за ті дні, в яких послуга не надавалася;</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>якщо через будь-які технічні неполадки послуга не надавалася, повернення сплачених грошових коштів здійснюється після надання користувачем доказів оплати. В такому випадку повернення грошових коштів відображається в Акаунті Користувача з можливістю використання сплачених грошових коштів у майбутньому;</span>
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')}>при оплаті Сервісу з видалених Компанією облікових записів, які були продубльовані Користувачем в порушення умов цієї Угоди. Таке повернення здійснюється Компанією виключно за зверненням Користувача, а грошові кошти повертаються на активний обліковий запис такого користувача з можливістю використання сплачених грошових коштів у майбутньому.</span>
                    </li>
                  </ul>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Грошові кошти, Користувачам, Акаунти яких заблоковані або видалені на підставі пункту 4.1.4 цієї Угоди, не повертаються.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Права інтелектуальної власності" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Всі об'єкти, доступні за допомогою Сервісів, у тому числі елементи дизайну, текст, графічні зображення, ілюстрації, відео, програми, бази даних, музика, звуки і інші об'єкти, а також будь-який контент, розміщений на сервісах Порталу, є об'єктами виняткових прав Компанії, користувачів та інших правовласників. Ніякі елементи змісту сервісів Порталу, а також будь-який контент, розміщений на сервісах Порталу, не можуть бути використані іншим чином без попереднього дозволу Компанії або Правовласника. Під використанням маються на увазі, в тому числі, але не виключно (відтворення, копіювання, переробка, поширення на будь-якій основі та ін.).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Назва Порталу є зареєстрованим товарним знаком і охороняється чинним законодавством України, а також міжнародним.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Портал та Контент Компанії є об'єктом авторського права, що охороняється чинним законодавством України.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія не дозволяє використання назви Порталу і/або Контенту Компанії, крім як на умовах письмового ліцензійного договору, якщо інше не зазначено в цій Угоді або Ключових Документах.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Будучи об'єктом авторського права Компанії, Портал одночасно включає Контент Користувача. Користувач надає Компанії чинне без обмеження території та терміну невиключне, субліцензійне право на використання Контенту Користувача будь-якими способами, включаючи, але не обмежуючись (публікація, збір, демонстрація, копіювання, дублювання, відтворення, доведення до загального відома). Перераховані вище права надаються Компанії безоплатно (без виплати винагороди).</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач погоджується з тим, що його Контент може бути використаний Компанією на власний розсуд під час підготовки рекламних матеріалів, статей, звітів, аналізів та іншого без додаткової згоди з боку Користувача і без виплати винагороди.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач надає право на доступ до його Контенту всіх Користувачів Порталу.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач гарантує і несе всю відповідальність за дотримання авторських прав на його Контент і відшкодовує Компанії всі збитки, понесені останньою у випадку врегулювання претензій і спорів за участю третіх осіб, що виникли у зв'язку з порушенням Користувачем прав інтелектуальної власності на надану їм інформацію.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Обмеження відповідальності Компанії та Власника Порталу" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач розуміє і повністю погоджується з тим, що:</span>
                  <ul {...bemClasses('ul', 'square')}>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="господарську діяльність і надання Сервісів через Портал здійснює Компанія. Тому, Власник Порталу не несе відповідальності перед Користувачами, в тому числі і в рамках цієї Угоди, якщо інше прямо не передбачено законодавством;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Сервіс надається на умовах «як є». Компанія докладає всіх зусиль для безперервного і безпомилкового надання Сервісу Користувачеві, але не гарантує помилок і збоїв, в тому числі щодо роботи програмного забезпечення. Компанія докладе всіх зусиль для усунення будь-яких збоїв і помилок, в разі їхнього виникнення, в максимально стислі терміни;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не несе відповідальності за будь-який несанкціонований доступ або використання серверів Порталу і/або будь-якої інформації, що зберігається на нихпро Користувачів, а також за будь-які помилки, віруси, «троянських коней» та інше, які можуть бути передані на Портал або через нього третіми особами;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не гарантує, що Сервіси будуть відповідати вимогам Користувача;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не гарантує, що якість товарів і послуг, придбаних за допомогою Порталу, буде відповідати очікуванням і/або вимогам Користувача;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не є організатором/ініціатором/гарантом угод між Користувачами. Портал є комунікаційною платформою, яка надає Користувачам можливість спілкування і розміщення їхнього Контенту відповідно до даної Угоди та Ключових документів;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Весь Контент Компанії публікується на Порталі виключно з інформаційною метою і Користувач не може посилатися на нього, як на експертні висновки, якщо інше прямо не сказано в певному Контенті;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не може контролювати достовірність розміщення Користувачами інформації. Компанія не несе відповідальності за будь-які збитки, завдані в результаті не вчинення правочину або неналежної поведінки будь-якої зі сторін угоди;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Користувач зобов'язується дотримуватися обережності і зберігати здоровий глузд при користуванні Сервісами. Користувач повинен прийняти до уваги, що його контрагент може бути неповнолітнім або видавати себе за іншу особу. Використання Сервісів має на увазі, що Користувач усвідомлює і приймає ці ризики, а також погоджується, що Компанія не несе відповідальності за дії або бездіяльність з боку Користувача;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="Компанія не несе відповідальності за поведінку користувачів і/або за Контент користувачів. Всі суперечки і конфлікти між Користувачами вирішуються ними самостійно без залучення Компанії;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="якщо у Користувача виникають претензії до іншого Користувача в результаті використання Сервісів, Користувач погоджується пред'являти ці вимоги самостійно і без втручання з боку Компанії, а також звільняє Компанію від всіх вимог, зобов'язань, компенсацій по відшкодуванню збитків і витрат, включаючи витрати на юридичні послуги, що виникли в результаті або у зв'язку з такими вимогами;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="скачування будь-якої інформації або матеріалів з Порталу здійснюється на свій страх і ризик. Користувачі повністю відповідальні за втрату інформації або шкоду, завдану їхньому комп'ютеру внаслідок скачування інформації з Порталу;" />
                    </li>
                    <li {...bemClasses('li')}>
                      <span {...bemClasses('text')} children="бездіяльність із боку Компанії в разі порушення Користувачем або іншими користувачами положень Угоди не позбавляє Компанію права застосовувати відповідні дії на захист своїх інтересів пізніше, а також не означає відмови Компанії від своїх прав у разі вчинення в подальшому подібних порушень." />
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Внесення змін до угоди" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>
                    Угода може бути змінена Компанією в односторонньому порядку без будь-якого спеціального повідомлення Користувача. Нова редакція Угоди вступає в силу з моменту її розміщення в мережі Інтернет за вказаною в цьому абзаці Угоди адресою, якщо інше не передбачено новою редакцією Угоди. Чинна редакція Угоди завжди знаходиться на Порталі за адресою:&ensp;
                      <Link
                        {...bemClasses('link')}
                        builder={linksDomik.sectionTermsUse}
                        builderProps={{ title: i18n('termsUser') }}
                      >
                        <span {...bemClasses('linkContent')}>
                          <span {...bemClasses('text', 'link')} children={`https://www.domik.ua/uk/copyright.html#${sectionId[0]}`} />
                        </span>
                      </Link>
                    .
                  </span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Термін дії Угоди" />
              <ol {...bemClasses('ol', 'list')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Ця Угода набуває чинності з моменту його прийняття Користувачем в порядку, зазначеному вище, і діє протягом усього періоду використання Користувачем Сервісів.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Користувач має право припинити свою реєстрацію на Порталі в односторонньому порядку без попереднього повідомлення про це Компанії та пояснення причин.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>У разі, якщо Компанією були внесені будь-які зміни до Угоди в порядку, передбаченому пунктом 8 Угоди, з якими Користувач не згоден, він зобов'язаний припинити використання Сервісів. Факт не припинення використання Порталу є підтвердженням згоди Користувача з відповідною редакцією Угоди.</span>
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')}>Компанія має право розірвати Угоду шляхом видалення або блокування Акаунта Користувача у випадках, передбачених пунктами 4.1.4 і 4.1.5 Угоди.</span>
                </li>
              </ol>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Додатки до Угоди:" />
              <ul {...bemClasses('ul', 'hyphen')} children={docsMainWithText} />
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')} children="Реквізити Компанії:" />
              <div {...bemClasses('text')}>
                <p children="Приватне підприємство «РЕКЛАМНЕ АГЕНТСТВО ДОМІК НЕТ»," />
                <p children="ЄДРПОУ 36080646" />
                <p children="юр. адреса: 04210, м. Київ, Оболонський р-н, пр-т Героїв Сталінграда, 6б, кор. 3, оф.1" />
                <p>тел.: {telDomik}</p>
              </div>
            </li>
          </ol>
        </Trans>
      </div>
    );
  }
}

export function renderLinkToMain(text) {
  return (
    <Link
      {...bemClasses('link')}
      builder={linksDomik.sectionDomik}
      builderProps={{ title: text }}
    >
      <span {...bemClasses('linkContent')}>
        <span {...bemClasses('text', 'link')} children={text} />
      </span>
    </Link>
  );
}
